import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container, Table } from 'semantic-ui-react';
import { formatNumber } from '~/utils/helpers';
import styled from 'styled-components';

const StyledTable = styled(Table)`
  &&& {
    width: 100%;
    max-width: 800px;
    margin: auto;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
`;

const StyledTableCell = styled(Table.Cell)`
  &&& {
    font-weight: bold;
  }
`;

interface ContractInfoDataType {
  accountName: string;
  accountType: string;
  assetClass: string;
  marketPrice: string;
  marketValue: string;
  masterAccountName: string;
  masterCompanyCountry: string;
  productGroup: string;
  productSubGroup: string;
  productUnderlyer: string;
}

interface ContractInfoProps {
  data: ContractInfoDataType;
}

const ContractInfo: React.FC<ContractInfoProps> = ({ data }) => {
  const { t } = useTranslation()

  return (
    <Container>
      <StyledTable definition>
        <Table.Body>
          <Table.Row>
            <StyledTableCell width={4}>{t('Account Name')}</StyledTableCell>
            <Table.Cell>{data.accountName}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <StyledTableCell>{t('Account Type')}</StyledTableCell>
            <Table.Cell>{data.accountType}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>{t('Asset Class')}</Table.Cell>
            <Table.Cell>{data.assetClass}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>{t('Market Price')}</Table.Cell>
            <Table.Cell>{formatNumber(data.marketPrice)}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>{t('Market Value')}</Table.Cell>
            <Table.Cell>{formatNumber(data.marketValue, 0)}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>{t('Master Account Name')}</Table.Cell>
            <Table.Cell>{data.masterAccountName}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>{t('Master Company Country')}</Table.Cell>
            <Table.Cell>{data.masterCompanyCountry}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>{t('Product Group')}</Table.Cell>
            <Table.Cell>{data.productGroup}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>{t('Product SubGroup')}</Table.Cell>
            <Table.Cell>{data.productSubGroup}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>{t('Product Underlyer')}</Table.Cell>
            <Table.Cell>{data.productUnderlyer}</Table.Cell>
          </Table.Row>
        </Table.Body>
      </StyledTable>
    </Container>
  );
};
export default ContractInfo

